// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__1ejSu","text":"style_text__1StCd","description":"style_description__6Hobj","actions":"style_actions__SwkQa","actions_btn":"style_actions_btn__GGyY0"};